import React from 'react'
import { FormRow, FormDashboardLabel as Label, User, TagItem } from '../../../components'
import Select from 'react-select'

const PartnerPopupSelect = ({setType}) => {
  return (
    <div>
      <FormRow>
        <Label>Choose Partners</Label>
        <div className="lg:w-2/3 mb-5">
          <Select options={[]} placeholder="Search Partners" className="text-sm"/>
        </div>
        <div className="flex flex-wrap">
          <div className="mr-4 lg:mr-2 mb-4 lg:mb-2">
            <TagItem value="Organisasi A"/>
          </div>
          <div className="mb-4 lg:mb-2">
            <TagItem value="Organisasi B"/>
          </div>
        </div>
      </FormRow>

      <hr className="my-5 lg:my-8"/>

      <p className="mb-5 lg:mb-10 text-sm">
        Sebagian partner tidak ditemukan? <span className="link" onClick={() => setType('form')}>Klik disini untuk menambah secara manual</span>
      </p>

      <div className="lg:w-1/3">
        <div className="flex items-center justify-between mb-2">
          <User small name="AIPJ2"/>
          <p className="text-xs text-gray-999 underline cursor-pointer">Delete</p>
        </div>
        <div className="flex items-center justify-between mb-3">
          <User small name="Maarif Institute"/>
          <p className="text-xs text-gray-999 underline cursor-pointer">Delete</p>
        </div>
      </div>
    </div>
  )
}

export { PartnerPopupSelect }